/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by deploy.sh at 2026-09-29T13:03:17Z
 * Environment: prod
 */

export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_oRiuJ8i6z',
      userPoolClientId: '7ap69v48c0u1oav25i7jm5bfu4',
    },
  },
  API: {
    endpoint: 'https://coxzwrqdt3.execute-api.us-east-1.amazonaws.com/prod',
  },
};
